import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

const mergeField = <T>(country: T, locale: T): T => country ?? locale;

function assertSixAmounts(value: unknown): readonly number[] {
	if (!Array.isArray(value)) throw new Error('amounts must be an array');
	if (value.length !== 6) throw new Error(`amounts must have exactly 6 values, got ${value.length}`);
	return value as readonly number[];
}

export const FCM_PROMOTE_AMOUNT_BUTTONS_SIMPLIFIED_EXPERIMENT = defineFcm(
	'promote_amount_buttons_simplified_experiment',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string', optional: true },
				variant_static_amount_1: {
					type: 'object',
					shape: {
						amounts: { type: 'array', shape: { type: 'number' }, normalizer: assertSixAmounts },
					},
					optional: true,
				},
				variant_static_amount_2: {
					type: 'object',
					shape: {
						amounts: { type: 'array', shape: { type: 'number' }, normalizer: assertSixAmounts },
					},
					optional: true,
				},
				exclusion_group_experiment_id: { type: 'string', optional: true },
			},
		}),
	)
	.withDefault(undefined)
	.withMerger(({ countryValue, localeValue }) => {
		if (!countryValue && !localeValue) return undefined;
		const cv = countryValue ?? {};
		const lv = localeValue ?? {};
		return {
			experimentName: mergeField(cv.experimentName, lv.experimentName),
			variant_static_amount_1: mergeField(cv.variant_static_amount_1, lv.variant_static_amount_1),
			variant_static_amount_2: mergeField(cv.variant_static_amount_2, lv.variant_static_amount_2),
			exclusion_group_experiment_id: mergeField(cv.exclusion_group_experiment_id, lv.exclusion_group_experiment_id),
		};
	})
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'promote',
		description:
			'Static six-amount ladders for the promote page static-amounts experiment. exclusion_group_experiment_id is the member id to check this experiment against in FCM_PROMOTE_PAGE_EXCLUSION_GROUP; leave unset to run unconditionally, bypassing the exclusion group entirely.',
		supportedGroups: { locales: true, countries: true },
		mergeLogic: 'each property: country value wins, else locale value',
		template: {
			experimentName: '',
			exclusion_group_experiment_id: 'promote_amount_buttons_simplified_experiment',
			variant_static_amount_1: { amounts: [3, 10, 25, 50, 100, 250] },
			variant_static_amount_2: { amounts: [5, 15, 35, 75, 150, 300] },
		},
		deprecated: 'FCM no longer in use (static amounts not shipped, control kept) — safe to delete after 2026-11-06',
	});
